import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EntryFormState {
    entryFormStep: string;
    externalId: string;
    publicId:string;
    planId_E_KYC_HO: string;
    planId_CORPORATE_NUMBER: string;
    planId_PUBLIC_PERSONAL_AUTHENTICATION: string;
    planId_CORPORATE_VERIFICATION_CERTIFICATE_OF_AL_REGISTERED_MATTERS: string;
    planId_SUPPLEMENTARY_DOCUMENT_VERIFICATION_SERVICE_LETTER_OF_ATTORNEY: string;
    companyName: string;
    corporateNumber: string;
    companyPostalCode: string;
    companyPrefecture: string;
    companyCity: string;
    companyStreetAddress: string;
    companyBuilding: string;
    representativeFirstName: string;
    representativeLastName: string;
    firstName: string;
    lastName: string;
    firstNameKa: string;
    lastNameKa: string;
    birthday: string;
    postalCode: string;
    prefecture: string;
    city: string;
    address: string;
    building: string;
    gender: string;
    phoneNum: string;
    email: string;
    selectedRole: string;
    submissionDate: string;
}

export const initialState: EntryFormState = {
    entryFormStep: 'entry',
    externalId: '',
    publicId: '',
    planId_E_KYC_HO: '',
    planId_CORPORATE_NUMBER: '',
    planId_PUBLIC_PERSONAL_AUTHENTICATION: '',
    planId_CORPORATE_VERIFICATION_CERTIFICATE_OF_AL_REGISTERED_MATTERS: '',
    planId_SUPPLEMENTARY_DOCUMENT_VERIFICATION_SERVICE_LETTER_OF_ATTORNEY: '',
    companyName: '',
    corporateNumber: '',
    companyPostalCode: '',
    companyPrefecture: '',
    companyCity: '',
    companyStreetAddress: '',
    companyBuilding: '',
    representativeFirstName: '',
    representativeLastName: '',
    firstName: '',
    lastName: '',
    firstNameKa: '',
    lastNameKa: '',
    birthday: '',
    postalCode: '',
    prefecture: '',
    city: '',
    address: '',
    building: '',
    gender: '',
    phoneNum: '',
    email: '',
    selectedRole: '',
    submissionDate: '',
};
const entryFormSlice = createSlice({
    name: 'entryForm',
    initialState,
    reducers: {
        // Set individual field
        setField: (state, action: PayloadAction<{ field: keyof EntryFormState; value: string }>) => {
            const { field, value } = action.payload;
            state[field] = value;
        },
        
        // Set multiple fields at once
        setMultipleFields: (state, action: PayloadAction<Partial<EntryFormState>>) => {
            Object.assign(state, action.payload);
        },
        
        // Reset form to initial state
        resetForm: (state) => {
            Object.assign(state, initialState);
        }
    },
});

export const { setField, setMultipleFields, resetForm } = entryFormSlice.actions;

export default entryFormSlice.reducer;